import {
    CHANGE_OPTION_RADIO_CONFIRMED,
    CHANGE_DATES_PAYMENT,
    CHECKED_PAYMENT_METHODS,
    GET_PAYMENTS_BY_FILTERS
} from '../constants/payments_budgets';
 
 export const payments_budgets = ( state = {}, action ) => {
    switch ( action.type ) {
        
        case CHANGE_OPTION_RADIO_CONFIRMED : {
            return action.payload;
        }

        case CHANGE_DATES_PAYMENT : {
            return action.payload;
        }

        case CHECKED_PAYMENT_METHODS : {
            return action.payload;
        }

        case GET_PAYMENTS_BY_FILTERS : {
            return action.payload;
        }
        
        default :
            return state;
    }
}